import { render, staticRenderFns } from "./NasalSwabAction.vue?vue&type=template&id=6780f0f1&scoped=true&"
import script from "./NasalSwabAction.vue?vue&type=script&lang=js&"
export * from "./NasalSwabAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6780f0f1",
  null
  
)

export default component.exports